// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1eWbZYY5hj_calculator","block":"N915iqD3AB_calculator"};